import './index_mWeb.css';
import FlatList from 'flatlist-react';
import { useDispatch, useSelector } from 'react-redux';
import { FlatListWrapper, HeaderWithTimer, View, Text, RouteWrapper } from '../../../component';
import useGame from '../../../utilities/hooks/game';
import I18n from '../../../utilities/locale';
import { ContestConfirmModal } from '../../component';
import { useLink } from 'react-router-stack';
import { BsCheckSquareFill, BsSquare } from 'react-icons/bs';
import TeamBoxMWeb from '../../component/team_box/index_mWeb';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const MyTeamsList = ({
  matchItem,
  selectAll,
  gameType,
  myTeamList,
  selectTeamByUser,
  onPressPreview,
  onPressClone,
  onPressEdit,
  onPressAlreadyJoin,
  lineupsOut,
  title,
  matchAllPlayersList,
  contestTeams,
  tabType,
  onPressAddTeam,
  onPressJoinContest,
  totalTeamsCount,
  selectedTeamIdList,
  isTeamSwitch,
  contestConfirmModal,
  joinContest,
  bonusPercentage,
  setContestConfirmModal,
  onPressSelectAll
}: any) => {
  const navigate = useLink();
  const { fantasyMatchClick } = useGame();
  const { teamName = '' } = useSelector((state: any) => state.user);
  const { maxTeamPerUser = 1, contest = {} } = matchItem;
  const { entryFee = 0 } = contest;

  const dispatch = useDispatch();

  const createTeamBtnColor: any = {
    backgroundColor: '#19232c',
    color: '#ffc400',
    border: `1px solid #ffc400`
  };

  const switchTeamColor: any = {
    backgroundImage: 'linear-gradient(to bottom, #f6c53f, #ffc300)',
    color: '#000',
    border: 'solid 1px #fff079'
  };

  const disableBtn = {
    color: '#b6bcc4',
    backgroundColor: '#758292'
  };

  const onCalledDeadline = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onPressBack = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: false,
          contestId: '',
          entryFee: '',
          isTeamSwitch: false,
          myContestJoinedTeams: [],
          contestType: {},
          teamData: {}
        }
      })
    );

    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const renderItem = (item: any) => {
    return (
      <TeamBoxMWeb
        selectTeamByUser={selectTeamByUser}
        joinedMatch={true}
        item={item}
        key={item.matchTeamId}
        onPressPreview={onPressPreview}
        onPressClone={onPressClone}
        onPressEdit={onPressEdit}
        onPressAlreadyJoin={onPressAlreadyJoin}
        lineupsOut={lineupsOut}
        title={title}
        matchAllPlayersList={matchAllPlayersList}
        contestTeams={contestTeams}
        gameType={gameType}
        tabType={tabType}
      />
    );
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <HeaderWithTimer
          onPressBack={onPressBack}
          matchItem={matchItem}
          onCalledDeadline={onCalledDeadline}
          teamName={teamName}
          isCreateTeam={false}
        />
        <View className="my-team-list-container_mWeb">
          {!isTeamSwitch && maxTeamPerUser > 1 && (
            <View className={'my-team-list-select-all-container_mWeb'} onPress={onPressSelectAll}>
              {selectAll ? (
                <BsCheckSquareFill size={'20px'} fill={'#fff'} />
              ) : (
                <BsSquare size={'20px'} fill={'#fff'} />
              )}
              <Text
                className={'my-team-list-select-all_mWeb'}
                style={{
                  color: '#fff'
                }}>
                {'Select All'}
              </Text>
            </View>
          )}
          <FlatListWrapper
            style={{
              paddingBottom: '150px'
            }}>
            <FlatList list={myTeamList} renderItem={renderItem} renderOnScroll />
          </FlatListWrapper>

          <View className={'my-team-list-bottom-card_mWeb'}>
            {totalTeamsCount < 11 && (
              <button
                className={'myTeamList__create__button__mWeb'}
                onClick={onPressAddTeam}
                style={createTeamBtnColor}>
                {I18n.t('createTeam')}
              </button>
            )}
            <button
              className={'myTeamList__create__button__mWeb'}
              onClick={onPressJoinContest}
              style={selectedTeamIdList.length > 0 ? switchTeamColor : disableBtn}
              disabled={selectedTeamIdList.length === 0 ? true : false}>
              {isTeamSwitch ? I18n.t('switchTeam') : I18n.t('joinContest')}
            </button>
          </View>
          <ContestConfirmModal
            visible={contestConfirmModal}
            onPressDismiss={() => setContestConfirmModal(false)}
            entryFee={entryFee / 100}
            selectedTeamCount={selectedTeamIdList.length}
            joinContest={joinContest}
            bonusPercentage={bonusPercentage}
          />
        </View>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default MyTeamsList;
